export const baseUrl = 'http://www.nsinova.com.br/abas/novo/api/allus'

export const loginUrl = 'http://teste.nsinova.com.br/allus/api/autenticador/autenticar'